<template>
  <div
    v-if="isImageValid"
    class="copilot-anpr-thumbnail"
    :style="{ height: `${height}px` }"
  >
    <img
      :src="thumbnailUrl"
      alt="thumbnail"
      class="copilot-anpr-thumbnail__img"
      @error="handleImageError"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue"
import { getAiApiUrl } from "@evercam/shared/api/aiApi"

export default Vue.extend({
  name: "CopilotAnprThumbnail",
  props: {
    url: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      isImageValid: true,
    }
  },
  computed: {
    thumbnailUrl(): string {
      const url = `${getAiApiUrl()}${this.url
        .replace("grt_", "")
        .replace("_grt", "")}?authorization=${this.token}`

      return this.$nuxt.$imgproxy.get720pResizedImageUrl(url)
    },
  },
  methods: {
    handleImageError() {
      this.isImageValid = false
    },
  },
})
</script>
